(function () {
    'use strict';

    angular
        .module('tikonApp')
        .controller('UpsertOrderBagController', UpsertOrderBagController);

    UpsertOrderBagController.$inject = ['$state', '$timeout', '$scope', 'entity', '$stateParams', 'OrderBag', 'ServiceItemCustom', 'ServiceTimeSessionInfoCustom', 'ServiceTimeSession', 'CustomerCustom', 'Customer', 'Principal'];

    function UpsertOrderBagController($state, $timeout, $scope, entity, $stateParams, OrderBag, ServiceItemCustom, ServiceTimeSessionInfoCustom, ServiceTimeSession, CustomerCustom, Customer, Principal) {
        var vm = this;
        vm.scope = $scope;
        vm.orderBag = entity;
        vm.clear = clear;
        //vm.datePickerOpenStatus = {};
        //vm.openCalendar = openCalendar;
        vm.save = save;
        //vm.serviceItems = ServiceItemCustom.getServiceItemsByCurrentCompany().query();
        //vm.selectedServiceItem = null;
        vm.serviceItem_changed = serviceItem_changed;
        vm.formState = "orderBagItem";
        vm.serviceSelected = serviceSelected;
        vm.findCustomer = findCustomer;
        vm.newCustomer = newCustomer;
        vm.customerMode = "find";
        vm.findCustomerKeyPress = findCustomerKeyPress;
        vm.states = $stateParams;
        vm.formMode = 'new';
        vm.authorityRole = authorityRole;
        Principal.hasAuthority("ROLE_CUSTOMER_MANAGER").then(function (has) {
            vm.isCustomerManager = has;
        });

        vm.selectedCustomerChanged = function (selectedItem) {
            if (selectedItem) {
                var c = Customer.get({id: selectedItem.id});
                if (c != null) {
                    vm.orderBag.customer = c;
                }
            }
        }
        vm.selectedCustomer = null;
        vm.searchCustomer = function (query) {
            return CustomerCustom.searchCustomerBySearch(query).query();
        }

        $timeout(function () {
            angular.element('.form-group:eq(1)>input').focus();
        });

        load();

        function load() {
            if ($stateParams.serviceItemId != null && $stateParams.serviceItemId != undefined) {
                vm.formMode = 'fromURL'
            }
            if ($stateParams.customerId != null && $stateParams.customerId != undefined) {
                vm.formMode = 'fromURLCustomer'
                findCustomerById($stateParams.customerId).then(function (result) {

                    if (result != null) {
                        vm.orderBag.customer = result;
                    }
                });


            }

        }


        function clear() {
            //$uibModalInstance.dismiss('cancel');
        }

        function save() {

            //if(vm.scope.editForm.$valid) {

            vm.isSaving = true;
            if (vm.orderBag.id !== null) {
                OrderBag.update(vm.orderBag, onSaveSuccess, onSaveError);
            } else {
                OrderBag.save(vm.orderBag, onSaveSuccess, onSaveError);
            }
            //}
        }

        function onSaveSuccess(result) {
            $scope.$emit('tikonApp:orderBagUpdate', result);

            vm.isSaving = false;
            $state.transitionTo('supplierPanel.editOrderBag', {id: result.id});
            //$state.transitionTo('supplierPanel.orderBagList');
        }

        function onSaveError() {
            vm.isSaving = false;
        }

        function serviceItem_changed() {

        }

        function serviceSelected() {
            //  vm.formState = "orderBagItem";
        }

        function findCustomer() {

            vm.customerMode = "find";
            vm.orderBag.customer = {};
            if (vm.phoneNumberToFind != null && vm.phoneNumberToFind != undefined) {
                var c = CustomerCustom.getCustomerByPhoneNumber(vm.phoneNumberToFind).query();
                if (c != null) {
                    vm.orderBag.customer = c;
                }
            }
        }

        function newCustomer() {
            vm.phoneNumberToFind = "";
            vm.orderBag.customer = {};
            vm.customerMode = "new";
            vm.myRole = "ROLE_USER";
        }

        function findCustomerKeyPress(e) {
            if (e.keyCode === 13) {
                findCustomer();
                e.preventDefault();
                return false;
            }
            return true;
        }

        function findCustomerById(id) {
            return Customer.get({id: id}).$promise;
        }

        function authorityRole() {
            if (vm.customerMode == 'new') {
                return "ROLE_USER";
            } else {
                return "ROLE_CUSTOMER_MANAGER";
            }
        }


    }
})();
